/**
 * variable used for the presale smart contract
 * of different network
 */

import { Address, encodeFunctionData } from 'viem';
import { environment } from '../../../environments/environment';
import { IAllDataItems, IBalnceDataEVM, IBalnceDataSOL, ITokenData } from '../interfaces/wallet.interface';
import { ChainNamespace } from '@reown/appkit/networks';
import { readContracts } from '@wagmi/core';
import { getParam } from './app-enums';

export const staking = require('../../../assets/contracts/staking.json');
export const token = require('../../../assets/contracts/token.json');

export const presaleEth = require('../../../assets/contracts/presaleETH.json');
export const presaleBsc = require('../../../assets/contracts/presaleBSC.json');

export const eth_usdt_token = require('../../../assets/contracts/eth_usdt_token.json');
export const bsc_usdt_token = require('../../../assets/contracts/bsc_usdt_token.json');
export const multicallBsc = require('../../../assets/contracts/multicallBsc.json');
export const multicallEth = require('../../../assets/contracts/multicallEth.json');
export const eth_usdc_token = require('../../../assets/contracts/eth_usdc_token.json');
export const bsc_usdc_token = require('../../../assets/contracts/bsc_usdc_token.json');
export const presaleSol = require('../../../assets/contracts/presaleSOL.json');

/**
 * here the presale ABI and Address are set
 * for read, write and prepair contract
 */
export const stakeContract = {
  address: environment.stakingAddress as Address,
  abi: staking.abi,
} as const;

export const presaleContractEth = {
  address: environment.eth.presaleAddress as Address,
  abi: presaleEth.abi,
} as const;

export const presaleContractBsc = {
  address: environment.bsc.presaleAddress as Address,
  abi: presaleBsc.abi,
} as const;

export const ethUsdtContract = {
  address: environment.eth.usdTAddress as Address,
  abi: eth_usdt_token.abi,
} as const;

export const bscUsdtContract = {
  address: environment.bsc.usdTAddress as Address,
  abi: bsc_usdt_token.abi,
} as const;

export const multicallEthContract = {
  address: environment.eth.multicall as Address,
  abi: multicallEth.abi,
} as const;

export const multicallBscContract = {
  address: environment.bsc.multicall as Address,
  abi: multicallBsc.abi,
} as const;

export const ethUsdcContract = {
  address: environment.eth.usdcAddress as any,
  abi: eth_usdc_token.abi,
} as const;

export const bscUsdcContract = {
  address: environment.bsc.usdcAddress as any,
  abi: bsc_usdc_token.abi,
} as const;

export function getChainData(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return environment.eth;
    case environment.bsc.chainIdInt:
      return environment.bsc;
    // case environment.poly.chainIdInt:
    //   return environment.poly;
    default:
      return environment.eth;
  }
}

export function getPresaleContract(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return presaleContractEth;
    case environment.bsc.chainIdInt:
      return presaleContractBsc;
    // case environment.poly.chainIdInt:
    //   return presaleContractPoly;
    default:
      return presaleContractEth;
  }
}

export function getUSDTContract(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return ethUsdtContract;
    case environment.bsc.chainIdInt:
      return bscUsdtContract;
    // case environment.poly.chainIdInt:
    //   return polyUsdtContract;
    default:
      return ethUsdtContract;
  }
}

export function getUSDCContract(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return ethUsdcContract;
    case environment.bsc.chainIdInt:
      return bscUsdcContract;
    default:
      return ethUsdcContract;
  }
}

/**
 * method to adjust unsold token
 * @param arr the array that need to be adjusted
 * @param skipIndex index no that need to be ignored or skipped
 * @returns a fresh set of array after all adjustment
 */

export function skipIndexUpdate(arr: Array<any>, skipIndex: Array<any>): Array<any> {
  let newArr: number[] = [];
  for (let i = 0; i < arr.length; i++) {
    if (!skipIndex.includes(i)) {
      newArr.push(Number(arr[i]));
    }
  }
  return newArr;
}

/**
 * generate signature for wert transaction
 * @param amount Amount to spend
 * @returns signature data
 */
export async function getABI(amount: number, isStake: boolean = false, walletAddress: string): Promise<string> {
  //, chainId: number, wagmiConfig: any
  // const referralAddress = getParam('referralAddress') || "0x0000000000000000000000000000000000000000";
  // const isValidReferral = await checkIsValidReferral(referralAddress, chainId, walletAddress, wagmiConfig);
  // const referral = isValidReferral ? referralAddress : "0x0000000000000000000000000000000000000000";

  const data = encodeFunctionData({
    abi: presaleEth.abi,
    functionName: 'buyWithUSDCWERT',
    args: [walletAddress, amount, isStake], // Add "referral" if you need
  });
  return data;
}

export const getNativeAmount = async (amount: number, symbol: string, balanceData: IAllDataItems) => {
  let singleAmount = 0;
  switch (symbol) {
    case 'ETH':
      singleAmount = balanceData.buyHelprETH ?? 0;
      break;

    case 'BNB':
      singleAmount = balanceData.buyHelperBSC ?? 0;
      break;

    case 'SOL':
      singleAmount = balanceData.oneSol ?? 0;
      break;

    default:
      singleAmount = balanceData.buyHelprETH ?? 0;
  }
  return Math.floor(+(amount / +singleAmount));
};

/**
 * calculating the available no of token in exchange of inserted Usdt amount
 */

export async function getUSDTAmount(amount: number, chainId: number, balanceData: IAllDataItems) {
  let singleAmount = 0;
  switch (getChainData(chainId).chainIdInt) {
    case environment.eth.chainIdInt:
      singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
      break;

    case environment.bsc.chainIdInt:
      singleAmount = (balanceData.usdtBuyHelperBSC ?? 0) / Math.pow(10, 18);
      break;

    case environment.sol.chainIdInt:
      singleAmount = (balanceData?.solUsdt ?? 0) / Math.pow(10, 6);
      break;

    default:
      singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
  }
  return Math.floor(+(amount / +singleAmount));
}

/**
 * reverse calculation required amount (eth/bnb/usdt)
 * in exchange of inserted token
 * @param amount : no of token
 * @param mode : exchange mode
 * @returns : required amount
 */

export async function getDynamicAmount(amount: number, mode: string, chainId: number, balanceData: IBalnceDataEVM) {
  let singleAmount = 0;
  switch (getChainData(chainId).chainIdInt) {
    case environment.eth.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = balanceData.buyHelprETH;
      } else {
        singleAmount = balanceData.usdtBuyHelperETH / Math.pow(10, 6);
      }
      break;

    case environment.bsc.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = balanceData.buyHelperBSC;
      } else {
        singleAmount = balanceData.usdtBuyHelperBSC / Math.pow(10, 18);
      }
      break;

    // case environment.poly.chainIdInt:
    //   if (mode === 'getNativeAmount') {
    //     singleAmount = balanceData.onePoly;
    //   } else {
    //     singleAmount = balanceData.polyUsdt / Math.pow(10, 6)
    //   }
    //   break;

    default:
      if (mode === 'getNativeAmount') {
        singleAmount = balanceData.buyHelprETH;
      } else {
        singleAmount = balanceData.usdtBuyHelperETH / Math.pow(10, 6);
      }
      break;
  }
  return +(amount * singleAmount);
}

/**
 * reverse calculation required amount (eth/bnb/usdt)
 * in exchange of inserted token
 * @param amount : no of token
 * @param mode : exchange mode
 * @returns : required amount
 */

export async function getDynamicAmountv2(amount: number, symbol: string, category: string, tokensData: ITokenData[], chainId: number, balanceData: IAllDataItems) {
  let token = tokensData.filter((x: ITokenData) => x.symbol === symbol)[0];
  let singleAmount = chainId == environment.eth.chainIdInt ? balanceData.buyHelprETH : balanceData.buyHelperBSC;
  switch (symbol) {
    case 'ETH':
      singleAmount = balanceData.buyHelprETH;
      break;

    case 'BNB':
      singleAmount = balanceData.buyHelperBSC;
      break;

    case 'USDT':
      if (category === 'ETH') {
        singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
      } else if (category === 'SOL') {
        singleAmount = (balanceData.solUsdt ?? 0) / Math.pow(10, 6);
      } else {
        singleAmount = (balanceData.usdtBuyHelperBSC ?? 0) / Math.pow(10, 18);
      }
      break;

    case 'SOL':
      singleAmount = balanceData.oneSol;
      break;

    default:
      singleAmount = balanceData.usdtBuyHelperETH;
  }
  return +(amount * (singleAmount ?? 0));
}

export function getGasFees(chainId: number) {
  let gas = 0;
  switch (chainId) {
    case environment.eth.chainIdInt:
      gas = environment.eth.gasFees;
      break;
    case environment.bsc.chainIdInt:
      gas = environment.bsc.gasFees;
      break;
    case environment.sol.chainIdInt:
      gas = environment.sol.gasFees;
      break;
    default:
      gas = environment.eth.gasFees;
      break;
  }

  return gas;
}

export function isSolanaActivated(chainNameSpace: ChainNamespace[]) {
  return chainNameSpace?.filter((item) => item === 'solana').length > 0;
}

// export const checkIsValidReferral = async (referralAddress: string, chainId: number, walletAddress: string, config: any) => {
//   try {
//     if (typeof window == 'undefined') return;
//     const smartContracts = {
//       contracts: [
//         {
//           ...(chainId === environment.eth.chainIdInt ? presaleContractEth : presaleContractBsc),
//           functionName: 'checkReferralStatus',
//           chainId: chainId, // 28
//           args: [referralAddress],
//         },
//       ],
//     };

//     const result = await readContracts(config, smartContracts);
//     console.log('checkIsValidReferral', result);
//     const isRefferalAvailable = !!Number(result[0].result);
//     return !referralAddress || referralAddress === walletAddress ? false : isRefferalAvailable;
//   } catch (error) {
//     return false;
//   }
// };
export function isEmptyObject(obj: object): boolean {
  return Object.keys(obj).length === 0;
}
